// css =>
import "../../BaseStructure.css";
import Styled from "./mobileMenuBar.module.css";

// react =>
import { useState } from "react";
import { useNavigate } from "react-router-dom";

// store =>
import { useUserStore } from "../../hooks/useUserStore";

// icons =>
import MoonIcon from "../../Assets/Icons/moon.png";
import OptionIcon from "../../Assets/Icons/option.png";
import SupportIcon from "../../Assets/Icons/support.png";
import ProfileIcon from "../../Assets/Icons/profile.png";

// API =>
import backEnd from "../../services/Api";

// utils =>
import { LocalCSRFReceiver } from '../../utils/GetLocalCSRF';
import { FetchCSRF } from '../../utils/GetCSRF';

function MobileMenuBar(Props: { isAuthenticated: boolean }) {
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

    const handleLogOut = async () => {
        useUserStore.getState().setUser(null);
        localStorage.removeItem("user-storage");

        const csrf = await LocalCSRFReceiver();

        const result = await backEnd.post("users/user-logout/", {
            withCredentials: true,
            headers: {
                "X-CSRFToken": csrf,
            }
        })

        document.location.reload();
    }

    return(
        <>
            <div className={`row ${ Styled.MobileMenuFrame } `}>
                <div className="col-4">
                    <img src={ SupportIcon } alt="Support" className={ Styled.SupportIcon } style={{ float: 'left' }} />
                </div>

                <div className="col-4">
                    <h1>We Dook</h1>
                </div>

                <div className="col-4" onClick={() => {
                    if (isMenuOpen) {
                        setIsMenuOpen(false);
                    } else {
                        setIsMenuOpen(true);
                    }
                }}>
                    <img src={ OptionIcon } alt="option" className={ Styled.OptionIcon } />
                </div>
            </div>

            <div className={`row ${ Styled.MenuBox } ${ isMenuOpen ? Styled.open : '' }`} >
                <div className={`col-8 ${ Styled.MenuBoxMenuFrame } `}>
                    <div className="row">
                        <div className="col-12">.</div>

                        <div className={`col-12 ${ Styled.MenuProfilePart } `}>
                            {
                                Props.isAuthenticated && useUserStore.getState().user ? (
                                    <>
                                        <div className={ Styled.ProfileIconBorder }>
                                            <img src={ ProfileIcon } alt="Profile" />
                                        </div>
                                        <div className="col-12">
                                            <p>{ useUserStore.getState().user?.name + " " + useUserStore.getState().user?.last_name }</p>
                                        </div>
                                    </>
                                ) : (
                                    <div className={`col-11 ${ Styled.MenuOptions } ${ Styled.MenuLogInOption } `} onClick={() => {
                                        navigate("/log-in");
                                    }}>
                                        <h3>ورود / ثبت نام</h3>
                                    </div>
                                )
                            }
                        </div>

                        <div className={`col-11 ${ Styled.MenuOptions } `} onClick={() => {
                            navigate("/show-products");
                        }}>
                            <h3>محصولات</h3>
                        </div>
                        <div className={`col-11 ${ Styled.MenuOptions } `} onClick={() => {
                            navigate("/");
                        }}>
                            <h3>کاتالوگ</h3>
                        </div>
                        <div className={`col-11 ${ Styled.MenuOptions } `} onClick={() => {
                            navigate("/");
                        }}>
                            <h3>تماس با ما</h3>
                        </div>
                        <div className={`col-11 ${ Styled.MenuOptions } `} onClick={() => {
                            navigate("/");
                        }}>
                            <h3>درباره ی ما</h3>
                        </div>

                        {
                            Props.isAuthenticated && useUserStore.getState().user ? (
                                <div className={`col-11 ${ Styled.MenuOptions } `} onClick={ handleLogOut }>
                                    <h3>خروج از حساب کاربری</h3>
                                </div>
                            ) : (
                                null
                            )
                        }

                        <div className={`col-11 ${ Styled.ChangeThemeFrame } `}>
                            <div className={`col-3 ${ Styled.ChangeThemeIconFrame } `}>
                                <img src={ MoonIcon } alt="Moon" />
                            </div>
                            <div className="col-8">
                                <h3>حالت شب</h3>
                            </div>
                        </div>

                        <div className={`col-12 ${ Styled.HeramTextFrame } `}>
                            <small>Designed & Developed By</small>
                            <h2>HERAM Studio</h2>
                        </div>
                    </div>
                </div>

                <div className={`col-4 ${ Styled.MenuBoxTextFrame } `}>
                    <h1>WE DOOK</h1>
                </div>
            </div>
        </>
    );
}

export default MobileMenuBar;
